import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HyginestaftLinkComponent } from './hyginestaft-link/hyginestaft-link.component';
import { HyginestaftReportComponent } from './hyginestaft-report/hyginestaft-report.component';
import { BuildingImageDataComponent } from './building-image-data/building-image-data.component';
import { TicketReportsComponent } from './ticketing-reports/ticket-reports/ticket-reports.component';
import { HygineCleaningComponent } from './hygine-cleaning/hygine-cleaning.component';
import { HygineDayWiseReportComponent } from './hygine-day-wise-report/hygine-day-wise-report.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { HouseKeepingCommandCentreComponent } from './house-keeping-command-centre/house-keeping-command-centre.component';
import { HousekeepingDashboardComponent } from './housekeeping-dashboard/housekeeping-dashboard.component';

const routes: Routes = [
  {
    path: '', component: HyginestaftLinkComponent,
    children: [
      {
        path: 'building-image-data', component: BuildingImageDataComponent
      },
      {
        path: 'hygieneStaffAttendance', component: HyginestaftReportComponent
      },
      {
        path: 'hygiene-day-wise-report', component: HygineDayWiseReportComponent
      },
      {
        path: 'hygine-cleaning', component: HygineCleaningComponent
      },
      {
        path: 'hygiene-live-update', redirectTo: 'housekeeping-dashboard', pathMatch: 'full'
      },
      {
        path: 'house-keeping-command-centre', component: HouseKeepingCommandCentreComponent
      },
      {
        path: 'housekeeping-dashboard', component: HousekeepingDashboardComponent
      },
      {
        path: 'housekeeping-dashboard-tv',
        component: HousekeepingDashboardComponent,
        data: { hkdbTvView: true },
      },
      {
        path: 'ticketingStaffAttendance', component: TicketReportsComponent
      },
      { path: 'no-access', component: NoAccessComponent }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HygieneStaftReportRoutingModule { }
